(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hotelo-enquiry-measurement"] && !Shopify.designMode) return;
  try {
    (() => {
  const section = document.querySelector('[data-hotelo-quote-page]');
  if (!section || section.dataset.measurementReady) return;
  section.dataset.measurementReady = 'true';
  const key = 'hotelo_pending_enquiry';
  const form = section.querySelector('#HoteloQuoteForm');
  const success = section.querySelector('[data-hotelo-quote-success]');
  const reference = form?.querySelector('[data-hotelo-quote-id]');
  const readPending = () => {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; }
  };
  if (reference) {
    reference.value = 'HTL-' + crypto.randomUUID();
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      try {
        sessionStorage.setItem(key, JSON.stringify({
          id: reference.value,
          page: section.dataset.hoteloQuotePage,
          created: Date.now()
        }));
      } catch {}
    });
  }
  if (!success) return;
  const pending = readPending();
  if (!pending || !pending.id || !Number.isFinite(pending.created)) return;
  if (Date.now() - pending.created > 1800000) {
    try { sessionStorage.removeItem(key); } catch {}
    return;
  }
  let sent = false;
  const send = () => {
    if (sent || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return;
    const params = { form_id: 'HoteloQuoteForm', lead_source: 'website_quote_form' };
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', params);
    } else if (window.google_tag_manager && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'generate_lead', ...params });
    } else {
      return;
    }
    sent = true;
    try { sessionStorage.removeItem(key); } catch {}
  };
  send();
  document.addEventListener('visitorConsentCollected', send);
  window.addEventListener('load', send, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
